<template>
  <div v-show="position.show" class="text" :style="boxStyle">
    <a :style="fontStyle" :href="option.url" target="_blank" :title="position.title" v-if="option.url">{{
      textData
    }}</a>
    <a :style="fontStyle" href="javascript:;" :title="position.title" v-else v-html="textData"></a>
  </div>
</template>

<script>
export default {
  name: 'Texts',
  components: {},
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    position: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fontFamilyList: ['微软雅黑', '宋体', '黑体', '隶书', '幼圆', 'tahoma', 'arial']
    }
  },
  computed: {
    fontStyle() {
      const fontstyle = {
        'font-family': `${this.fontFamilyList[this.option.fontFamily]}`,
        'font-size': `${this.option.fontSize}px`,
        'text-align': `${this.option.textAlign}`,
        color: this.option.color,
        'font-weight': this.option.fontWeight ? 'bold' : 'normal'
      }
      return fontstyle
    },
    boxStyle() {
      const boxStyle = {
        'overflow-y': this.option.textOverflow
      }
      return boxStyle
    },
    textData() {
      let data = this.option.data
      if (this.option.unit) data = Math.round(data / 10000)
      if (this.option.thousands) data = data.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
      if (this.option.unit) data += '万'
      return data
    }
  },
  watch: {},
  mounted() {},
  created() {},
  methods: {}
}
</script>

<style scoped lang="less">
.text {
  width: 100%;
  height: 100%;
  position: relative;
  white-space: pre-line;
}
a {
  z-index: -1;
  text-decoration: none;
  display: block;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
}
</style>
